import { useState } from 'react';
import { api } from '../../lib/api';
import type { TenantStatus } from '../../lib/types';
import { ErrorAlert } from '../ErrorAlert';
import { Button } from '../ui';

const STATUS_OPTIONS: TenantStatus[] = ['onboarding', 'active', 'suspended'];

const STATUS_LABEL: Record<TenantStatus, string> = {
  onboarding: 'En configuración',
  active: 'Activo',
  suspended: 'Suspendido',
};

/** Cambiar el estado del tenant (PATCH /status). Vive fuera de las tabs: aplica a todo el tenant. */
export function TenantStatusControl({
  tenantId,
  current,
  onChanged,
}: {
  tenantId: string;
  current: TenantStatus;
  onChanged: () => void;
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function changeStatus(next: TenantStatus) {
    setError(null);
    setLoading(true);
    try {
      await api.tenants.setStatus(tenantId, next);
      onChanged();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="space-y-2">
      {error && <ErrorAlert message={error} />}
      <div className="flex gap-2 flex-wrap items-center">
        <span className="text-body-sm text-neutral-500 dark:text-neutral-400">Cambiar estado:</span>
        {STATUS_OPTIONS.filter((s) => s !== current).map((s) => (
          <Button
            key={s}
            variant={s === 'active' ? 'primary' : s === 'suspended' ? 'danger' : 'outline'}
            size="sm"
            onClick={() => changeStatus(s)}
            disabled={loading}
            loading={loading}
          >
            → {STATUS_LABEL[s]}
          </Button>
        ))}
      </div>
    </div>
  );
}
